import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {ListVentasEntidadComponent} from './list-ventas-entidad/list-ventas-entidad.component';


const routes: Routes = [
  {
    path: '',
    component: ListVentasEntidadComponent,
    pathMatch: 'full'
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VentasEntidadRoutingModule { }
